import activeGamesLogo from 'dashboard/assets/images/active-games-hub/active-games.jpg';
import chaosKartsLogo from 'dashboard/assets/images/active-games-hub/chaos-karts.png';
import hyperTagLogo from 'dashboard/assets/images/active-games-hub/hyper-tag.png';
import pacmanLiveLogo from 'dashboard/assets/images/active-games-hub/pacman-live.png';

export const ACTIVE_GAMES_HUB_FEATURES = Object.freeze({
  enabled: true,
  brandRail: true,
  brandedConversationCards: true,
  brandedConversationHeader: true,
  senderIdentityBanner: true,
  emailScope: true,
  visibleTransfer: true,
  activeGamesAi: true,
});

export const ACTIVE_GAMES_HUB_ALL_BRANDS_ID = 'all';
export const ACTIVE_GAMES_HUB_EMAIL_SCOPE_ID = 'email';
export const ACTIVE_GAMES_HUB_EMAIL_INBOX_IDS = Object.freeze([4, 5, 6, 7, 8]);
export const ACTIVE_GAMES_HUB_ALL_EMAIL_ID = 'all';
export const ACTIVE_GAMES_HUB_DEFAULT_EMAIL_TRIAGE_ID = 'needs_reply';

export const ACTIVE_GAMES_HUB_EMAIL_TRIAGE = Object.freeze([
  {
    id: 'needs_reply',
    icon: 'i-lucide-message-circle-reply',
    label: 'needs-reply',
    activeClass: 'bg-n-teal-3 text-n-teal-12 ring-2 ring-inset ring-n-teal-9',
  },
  {
    id: 'notifications',
    icon: 'i-lucide-bell-ring',
    label: 'automated-notification',
    activeClass:
      'bg-n-slate-4 text-n-slate-12 ring-2 ring-inset ring-n-slate-8',
  },
  {
    id: 'review',
    icon: 'i-lucide-scan-search',
    label: 'routing-review',
    activeClass:
      'bg-n-amber-3 text-n-amber-12 ring-2 ring-inset ring-n-amber-9',
  },
  {
    id: 'all',
    icon: 'i-lucide-layers-3',
    label: '',
    activeClass: 'bg-n-iris-3 text-n-iris-12 ring-2 ring-inset ring-n-iris-9',
  },
]);

export const ACTIVE_GAMES_HUB_EMAIL_MAILBOXES = Object.freeze([
  {
    id: ACTIVE_GAMES_HUB_ALL_EMAIL_ID,
    icon: 'i-lucide-mails',
    inboxIds: ACTIVE_GAMES_HUB_EMAIL_INBOX_IDS,
    activeClass: 'bg-n-iris-3 text-n-iris-12 ring-2 ring-inset ring-n-iris-9',
  },
  {
    id: 'info',
    icon: 'i-lucide-info',
    inboxIds: [4],
    activeClass: 'bg-n-blue-3 text-n-blue-12 ring-2 ring-inset ring-n-blue-9',
  },
  {
    id: 'events',
    icon: 'i-lucide-calendar-days',
    inboxIds: [5],
    activeClass:
      'bg-n-amber-3 text-n-amber-12 ring-2 ring-inset ring-n-amber-9',
  },
  {
    id: 'marketing',
    icon: 'i-lucide-megaphone',
    inboxIds: [6],
    activeClass: 'bg-n-ruby-3 text-n-ruby-12 ring-2 ring-inset ring-n-ruby-9',
  },
  {
    id: 'operations',
    icon: 'i-lucide-headphones',
    inboxIds: [8],
    activeClass: 'bg-n-teal-3 text-n-teal-12 ring-2 ring-inset ring-n-teal-9',
  },
  {
    id: 'finance',
    icon: 'i-lucide-receipt-text',
    inboxIds: [7],
    activeClass:
      'bg-n-slate-4 text-n-slate-12 ring-2 ring-inset ring-n-slate-9',
  },
]);

export const ACTIVE_GAMES_HUB_BRANDS = Object.freeze([
  {
    id: 'active_games',
    name: 'Active Games',
    shortName: 'Active',
    logo: activeGamesLogo,
    inboxIds: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    enabled: true,
    activeClass: 'bg-n-teal-3 text-n-teal-12 ring-2 ring-inset ring-n-teal-8',
    markerClass: 'bg-n-teal-9',
  },
  {
    id: 'chaos_karts',
    name: 'Chaos Karts',
    shortName: 'Chaos',
    logo: chaosKartsLogo,
    inboxIds: [11],
    enabled: true,
    activeClass:
      'bg-n-amber-3 text-n-amber-12 ring-2 ring-inset ring-n-amber-8',
    markerClass: 'bg-n-amber-9',
  },
  {
    id: 'pacman_live',
    name: 'PAC-MAN Live',
    shortName: 'PAC-MAN',
    logo: pacmanLiveLogo,
    inboxIds: [12],
    enabled: true,
    activeClass:
      'bg-n-amber-3 text-n-amber-12 ring-2 ring-inset ring-n-amber-8',
    markerClass: 'bg-n-amber-9',
  },
  {
    id: 'hyper_tag',
    name: 'Hyper Tag',
    shortName: 'Hyper Tag',
    logo: hyperTagLogo,
    inboxIds: [13, 14],
    enabled: true,
    activeClass: 'bg-n-iris-2 text-n-iris-12 ring-2 ring-inset ring-n-iris-9',
    markerClass: 'bg-n-iris-9',
  },
  {
    id: 'hyperfit_360',
    name: 'HyperFit 360',
    shortName: 'HF360',
    monogram: 'H360',
    logo: null,
    inboxIds: [],
    enabled: false,
    activeClass: '',
    markerClass: 'bg-n-slate-7',
  },
  {
    id: 'wh6',
    name: 'WH6',
    shortName: 'WH6',
    monogram: 'WH6',
    logo: null,
    inboxIds: [],
    enabled: false,
    activeClass: '',
    markerClass: 'bg-n-slate-7',
  },
]);

export const getActiveGamesHubBrand = brandId =>
  ACTIVE_GAMES_HUB_BRANDS.find(brand => brand.id === brandId);

export const getActiveGamesHubBrandForInbox = inboxId =>
  ACTIVE_GAMES_HUB_BRANDS.find(brand =>
    brand.inboxIds.includes(Number(inboxId))
  );

export const getActiveGamesHubBrandFromQuery = brandId => {
  if (!brandId || brandId === ACTIVE_GAMES_HUB_ALL_BRANDS_ID) {
    return null;
  }

  const brand = getActiveGamesHubBrand(brandId);
  return brand?.enabled ? brand : null;
};

export const isActiveGamesHubEmailScope = channel =>
  channel === ACTIVE_GAMES_HUB_EMAIL_SCOPE_ID;

export const getActiveGamesHubEmailMailbox = mailboxId =>
  ACTIVE_GAMES_HUB_EMAIL_MAILBOXES.find(mailbox => mailbox.id === mailboxId) ||
  ACTIVE_GAMES_HUB_EMAIL_MAILBOXES[0];

export const getActiveGamesHubEmailTriage = triageId =>
  ACTIVE_GAMES_HUB_EMAIL_TRIAGE.find(triage => triage.id === triageId) ||
  ACTIVE_GAMES_HUB_EMAIL_TRIAGE.find(
    triage => triage.id === ACTIVE_GAMES_HUB_DEFAULT_EMAIL_TRIAGE_ID
  );

export const buildActiveGamesHubBrandFilters = ({
  inboxIds,
  status,
  assigneeType,
  currentUserId,
  label = '',
}) => {
  const filters = [
    {
      attribute_key: 'inbox_id',
      attribute_model: 'standard',
      filter_operator: 'equal_to',
      query_operator: 'and',
      values: inboxIds.map(Number),
    },
    {
      attribute_key: 'status',
      attribute_model: 'standard',
      filter_operator: 'equal_to',
      query_operator: 'and',
      values: [status],
    },
  ];

  if (label) {
    filters.push({
      attribute_key: 'labels',
      attribute_model: 'standard',
      filter_operator: 'equal_to',
      values: [label],
    });
  }

  if (assigneeType === 'me') {
    filters.push({
      attribute_key: 'assignee_id',
      attribute_model: 'standard',
      filter_operator: 'equal_to',
      values: [Number(currentUserId)],
    });
  } else if (assigneeType === 'unassigned') {
    filters.push({
      attribute_key: 'assignee_id',
      attribute_model: 'standard',
      filter_operator: 'is_not_present',
      values: [],
    });
  }

  filters.forEach((filter, index) => {
    filter.query_operator = index === filters.length - 1 ? undefined : 'and';
  });

  return { payload: filters };
};
